
import React from "react";
import type { Client } from "@/types";

interface ClientInfoDisplayProps {
  client: Client;
}

export const ClientInfoDisplay: React.FC<ClientInfoDisplayProps> = ({ client }) => {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <span className="text-white/70 block">Email</span>
        <span className="text-white block">{client.email}</span>
      </div>
      {client.phone && (
        <div className="space-y-1">
          <span className="text-white/70 block">Phone</span>
          <span className="text-white block">{client.phone}</span>
        </div>
      )}
      {client.age && (
        <div className="space-y-1">
          <span className="text-white/70 block">Age</span>
          <span className="text-white block">{client.age}</span>
        </div>
      )}
      {client.gender && (
        <div className="space-y-1">
          <span className="text-white/70 block">Gender</span>
          <span className="text-white block">{client.gender}</span>
        </div>
      )}
      {client.goals && (
        <div className="space-y-1">
          <span className="text-white/70 block">Goals</span>
          <span className="text-white block">{client.goals}</span>
        </div>
      )}
      {typeof client.notes === 'string' && client.notes && (
        <div className="space-y-1">
          <span className="text-white/70 block">Notes</span>
          <span className="text-white block">{client.notes}</span>
        </div>
      )}
    </div>
  );
};
